'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
/* injects from baggage-loader */

exports.stupidRouteType = stupidRouteType;
exports.stupidRoute = stupidRoute;
exports.right = right;
exports.left = left;
exports.goRight = goRight;
exports.goLeft = goLeft;
exports.openIndex = openIndex;
exports.previewProject = previewProject;
exports.viewProject = viewProject;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _routing = require('../constants/routing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('metapro:actions:routing');

function stupidRouteType(_ref) {
  var userId = _ref.userId;
  var projectId = _ref.projectId;
  var nodeId = _ref.nodeId;
  var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  if (projectId) {
    if (nodeId) {
      return [preview ? _routing.JALAN_PROJECT_NODE : _routing.JALAN_NODE, { projectId: projectId, nodeId: nodeId }];
    }
    return [preview ? _routing.JALAN_INDEX_PROJECT : _routing.JALAN_PROJECT, { userId: userId, projectId: projectId }];
  }

  return [_routing.JALAN_INDEX, {}];
}

function stupidRoute() {
  var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var _stupidRouteType = stupidRouteType(params, preview);

  var _stupidRouteType2 = _slicedToArray(_stupidRouteType, 2);

  var type = _stupidRouteType2[0];
  var cleanParams = _stupidRouteType2[1];

  return { type: type, params: cleanParams };
}

function right(_ref2) {
  var routing = _ref2.routing;
  var type = routing.type;


  switch (type) {
    case _routing.JALAN_USER_LIST:
      return { type: _routing.JALAN_USER_LIST, params: routing.params };

    case _routing.JALAN_INDEX_PROJECT:
      return { type: _routing.JALAN_PROJECT, params: routing.params };

    case _routing.JALAN_PROJECT_NODE:
      return { type: _routing.JALAN_NODE, params: routing.params };

    case _routing.JALAN_INDEX:
      // fixes https://trello.com/c/QQdDWWO8/81-2-3
      return { type: _routing.JALAN_INDEX, params: {} };

    default:
      (0, _invariant2.default)(false, 'no right route for ' + type);
  }
}

function left(_ref3) {
  var project = _ref3.project;
  var routing = _ref3.routing;
  var type = routing.type;


  switch (type) {
    case _routing.JALAN_USER_LIST:
      return { type: _routing.JALAN_USER_LIST, params: { userId: routing.params.userId } };

    case _routing.JALAN_INDEX_PROJECT:
      return { type: _routing.JALAN_USER_LIST, params: { userId: routing.params.userId } };

    case _routing.JALAN_PROJECT:
      return {
        type: _routing.JALAN_INDEX_PROJECT,
        params: {
          projectId: routing.params.projectId, userId: project.owner
        }
      };

    case _routing.JALAN_PROJECT_NODE:
      return { type: _routing.JALAN_PROJECT, params: { projectId: routing.params.projectId } };

    case _routing.JALAN_NODE:
      return {
        type: _routing.JALAN_PROJECT_NODE,
        params: { projectId: routing.params.projectId, nodeId: routing.params.nodeId }
      };

    default:
      (0, _invariant2.default)(false, 'no left route for ' + type);
  }
}

function goRight() {
  return function (dispatch, getState) {
    var _getState = getState();

    var routing = _getState.routing;
    var project = _getState.projects.project;


    var data = { routing: routing, project: project };

    debug('go right', data);
    dispatch(right(data));
  };
}

function goLeft() {
  return function (dispatch, getState) {
    var _getState2 = getState();

    var routing = _getState2.routing;
    var project = _getState2.projects.project;


    var data = { routing: routing, project: project };

    debug('go left', data);
    dispatch(left(data));
  };
}

function openIndex() {
  return {
    type: _routing.JALAN_INDEX,
    params: {}
  };
}

function previewProject(userId, projectId) {
  return stupidRoute({ userId: userId, projectId: projectId }, true);
}

function viewProject(userId, projectId) {
  return stupidRoute({ userId: userId, projectId: projectId }, false);
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/routing.js
// module id = 44
// module chunks = 1